module.exports = __webpack_public_path__ + "static/media/2.17147a1e.svg";